import { render, staticRenderFns } from "./PrescriptionItemRadio.vue?vue&type=template&id=76657e02&scoped=true"
import script from "./PrescriptionItemRadio.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76657e02",
  null
  
)

export default component.exports